import { Button, Row } from "antd";
import { UserAddOutlined } from "@ant-design/icons";
import { useAssignTask } from "../hooks/useAssignTask";
import { useCallback } from "react";
import { usePermissions } from "../../../lib/hooks/usePermissions";

type TableAssignColumnProps = {
  id: string;
  isClosed: boolean;
  assignedToFullName: string | null;
  reload: () => void;
};

export const TableAssignColumn = ({
  id,
  isClosed,
  assignedToFullName,
  reload,
}: TableAssignColumnProps) => {
  const { isLoading, assign } = useAssignTask(id, reload);

  const { hasAccessByController } = usePermissions("WorkTasks");

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation();
      assign({ selfAssignment: true });
    },
    [assign],
  );

  return !assignedToFullName ? (
    hasAccessByController("Modify") && !isClosed ? (
      <Button
        type="dashed"
        icon={<UserAddOutlined />}
        shape="round"
        size="small"
        disabled={isLoading}
        loading={isLoading}
        onClick={onClick}
      >
        Assign to me
      </Button>
    ) : (
      <Row />
    )
  ) : (
    <span title={assignedToFullName}>{assignedToFullName}</span>
  );
};
